<small class="mention">
    <ng-content></ng-content>
</small>
